import Cookies from 'js-cookie';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import PageSpinner from 'App/components/PageSpinner';
import SessionStorageService from 'App/services/SessionStorageService';
import TokenManagerService from 'App/services/TokenManagerService';
import { workQueueRoute, logoutRoute } from 'App/common/routeLookup';

const propTypes = {};

const defaultProps = {};

function SupportLogin() {
    const navigate = useNavigate();

    useEffect(() => {
        if (Cookies.get('sso_jwt')) {
            const cookie = SessionStorageService.getJwt(); // consumes cookie, calls setTokens, clears LOGOUT_FLAG
            TokenManagerService.fetchInitialRefresh(cookie)
                .then(() => {
                    navigate(workQueueRoute, { replace: true });
                })
                .catch(() => {
                    navigate(logoutRoute, { replace: true });
                });
        } else {
            navigate(workQueueRoute, { replace: true });
        }
    }, [navigate]);

    return <PageSpinner />;
}

SupportLogin.propTypes = propTypes;
SupportLogin.defaultProps = defaultProps;

export default SupportLogin;
